import { useEffect } from 'react';

let busy = false;
const idleListeners = new Set<() => void>();

export const isCallBusy = (): boolean => busy;

export const setCallBusy = (next: boolean): void => {
  const wasBusy = busy;
  busy = next;
  if (!wasBusy || next) return;
  for (const listener of [...idleListeners]) listener();
};

export const subscribeToCallIdle = (listener: () => void): (() => void) => {
  idleListeners.add(listener);
  return () => { idleListeners.delete(listener); };
};

export const useReportCallBusy = (isBusy: boolean): void => {
  useEffect(() => {
    setCallBusy(isBusy);
    return () => { setCallBusy(false); };
  }, [isBusy]);
};
